module.exports = __webpack_public_path__ + "static/img/solutionDetailIcon05.1afbf9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailIcon05.png
// module id = fH0N
// module chunks = 0